<template>
  <div class="the-header relative w-full">
    <!-- Banner de fondo -->
    <div :class="['relative w-full', !$_inscriptionFormMixin_routesStatus.includes($route.name) ? 'shadow-lg h-48 md:h-64 lg:h-80 overflow-hidden' : null]">
      <img
        v-if="!$_inscriptionFormMixin_routesStatus.includes($route.name)"
        class="w-full h-full object-cover " 
        :src="banner" 
        alt="Zurich Marató Barcelona Banner"
      >
      
      <!-- Overlay para mejorar legibilidad del texto -->
      <div
        v-if="!$_inscriptionFormMixin_routesStatus.includes($route.name)"
        class="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/40"
      />
      
      <!-- Contenido superpuesto -->
      <div  class=" absolute inset-0 p-4 md:p-6 lg:p-[48px] flex flex-col justify-between">
        <!-- Header superior -->
        <div :class="['flex items-start', !$_inscriptionFormMixin_routesStatus.includes($route.name) ? 'justify-between' : 'justify-end']">
          <div
            v-if="!$_inscriptionFormMixin_routesStatus.includes($route.name)"
            class="flex items-center space-x-3"
          >
            <img
              :src="logo"
              alt="OWQLO"
              class="h-20"
            >
          </div>
          
          <!-- Powered by OWQLO -->
          <div class="flex items-center space-x-2 px-3 py-1">
            <img
              src="@/assets/logo-owqlo.svg"
              alt="OWQLO"
            >
          </div>
        </div>
        
        <!-- Contenido inferior -->
        <div class="flex justify-between items-end">
          <!-- Texto principal -->
          <div
            v-if="!$_inscriptionFormMixin_routesStatus.includes($route.name)"
            class="text-white max-w-3xl"
          >
            <h1 class="xl:text-[48px] font-bold mb-2 drop-shadow-lg leading-tight">
              <div v-if="$route.name !== 'inscription-upload-waiver'" class="block">
                {{ $t('common.inscribeTo') }}
              </div>
              <div class="block">
                {{ project?.name }}
              </div>
            </h1>
          </div>
          
          <!-- Ubicación -->
          <div
            v-if="!$_inscriptionFormMixin_routesStatus.includes($route.name)"
            class="flex items-center space-x-2 text-white px-4 py-2"
          >
            <svg
              class="w-6 h-6 md:w-7 md:h-7"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 21s6-5.686 6-10a6 6 0 10-12 0c0 4.314 6 10 6 10z"
              />
              <circle
                cx="12"
                cy="11"
                r="2"
                fill="currentColor"
              />
            </svg>
            <span class="sm:text-2xl font-light">{{ project?.city }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useDynamicFormStore } from '@/store/dynamicFormStore'
import { useProjectStore } from '@/store/projectStore.js'
import { useOrganizationStore } from '@/store/organizationStore'
import inscriptionFormMixin from '@/shared/utils/mixins/inscriptionFormMixin.js'

export default {
  name: 'TheHeader',
  mixins: [inscriptionFormMixin],
  computed: {
    ...mapState(useDynamicFormStore, { dynamicFormTemplate: 'dataUser' }),
    ...mapState(useOrganizationStore, ['organization']),
    ...mapState(useProjectStore, ['project']),
    banner: ({ project, organization }) => project?.heroHeader || organization?.banner,
    logo: ({ dynamicFormTemplate, project }) => dynamicFormTemplate?.logo || project?.logo,
    routesStatus: () => ['404', 'SoldOut', 'DeadLine', 'Closed'],
  },
}
</script>
<style lang="scss">
// Estilos específicos para el logo OWQLO cuando es necesario
.the-header .logo-owqlo--black {
  filter: brightness(0) invert(0) !important;
}
</style>
